import { colors, fonts, frames, glyphs, useMediaQuery } from "../../../../Styles";
import { CheckBox, CheckStyles, NewInput, PageHeader, Setting, LoadingSpinner, NewInputList } from "../../../../Components";
import NewButton from "../../../../Components/BaseComponents/Buttons/newButton";
import { ButtonTypes, ListStyle_Types, NewFieldStyles } from "../../../../Definitions";
import { useState } from "react";
import { CREATE_COMPANY, CreateCompanyArgs, CreateCompanyInput, CreateCompanyResponse } from "../../../../Services/Agrisys_GqlDataCaller/ServiceToolCalls/GQLCalls/createCompany";
import { useMutation } from "@apollo/client";

export default function CreateCompany() {
	const mobileXs = useMediaQuery(`(max-width: 570px)`);
	const [companyInput, setCompanyInput] = useState<CreateCompanyInput>({ domain: "", name: "" });

	const [createCompany, { data, loading, error, reset: resetCreateCompanyState }] = useMutation<CreateCompanyResponse, CreateCompanyArgs>(CREATE_COMPANY, {
		fetchPolicy: "network-only"
	});

	const isSuccess: boolean | undefined = data?.company.create.success;

	function setCompanyInputState<K extends keyof CreateCompanyInput>(key: K, value: CreateCompanyInput[K]) {
		setCompanyInput(prev => ({ ...prev, [key]: value }));
	}

	function isDomainValid(domain: string): boolean {
		const domainRegex = /^[a-z_]{1,12}$/;
		return domainRegex.test(domain);
	}

	function handleResetState() {
		setCompanyInput({ domain: "", name: "" });
		resetCreateCompanyState();
	}

	const companyFields: { key: keyof CreateCompanyInput; required?: boolean; maxLength?: number; }[] = [
		{ key: "domain", required: true, maxLength: 12 },
		{ key: "name", required: true },
		{ key: "city" },
		{ key: "street" },
		{ key: "phone" },
		{ key: "vat" },
		{ key: "email" }
	];

	const seperator = <div style={{ width: "95%", height: "2px", borderTop: "2px solid "+colors.greyTertiary, margin: "20px 0px" }} />
	
	return (
		<frames.Page_inner>
				<PageHeader topHeader='Create Company' subHeader='Overview' />
			<frames._page_inner_content_scroll>
			<div style={{display: "flex", gap: "20px", alignItems: "center", justifyContent: "center", flexDirection: "column"}}>

				<Setting
					startEnhancer={glyphs.FarmInfo({ size: "25px" })}
					header={"company"}
					content={
						<>
							
							<div style={{display: "flex", alignItems: "center", gap: "10px"}}>
								<NewButton
									buttonType={ButtonTypes.primaryButton}
									content={"Create"}
									overrides={{
										baseStyles: { width: "fit-content", backgroundColor: colors.greyTertiary, height: "30px", padding: "0 10px" },
										contentStyles: { color: colors.greyDarkPrimary, textShadow: "none", ...fonts.fontSize4 },
										hoverStyles: { backgroundColor: colors.greyLightPrimary, color: colors.greyDarkPrimary }
									}}
									onClick={() => { createCompany({ variables: { input: companyInput } })}}
									disabled={!isDomainValid(companyInput.domain) || !companyInput.name}
								/>
								<p style={{ ...fonts.fontSize4, ...fonts.paragraph, color: colors.greyDarkPrimary }}>NB: Domain must me lowercase letters and "_" only, max 12 characters!</p>
							</div>

							{seperator}
							
							{!isSuccess &&
								<div style={{display: "flex", flexDirection: "column", gap: "10px"}}>
									<NewInputList
										placeholders={companyFields.map(() => "")}
										headers={companyFields.map(f => f.key)}
										onChanges={companyFields.map(
											f => (e) => setCompanyInputState(f.key, e)
										)}
										valueOverrides={{
											maxValueLenghts: companyFields.map(f => f.maxLength)
										}}
										fieldOverrides={{ fieldStyle: NewFieldStyles.greyTertiary }}
										listOverrides={{
											listStyle: mobileXs
												? ListStyle_Types.centeredGroup
												: ListStyle_Types.group
										}}
										isRequired={companyFields.map(f => !!f.required)}
									/>
									<CheckBox
										text={"Legacy"}
										checkStyle={CheckStyles.grey}
										onChange={(e) => setCompanyInputState("legacy", e)}
										isChecked={companyInput.legacy}
									/>
								</div>
							}
							
							{loading && <LoadingSpinner />}
							
							{(error || !isSuccess === false) && 
								<p style={{ ...fonts.fontSize4, ...fonts.paragraph, color: colors.greyDarkPrimary, marginTop: "20px"}}>ERROR: failed to create company</p>
							}

							{!loading && !error && isSuccess && <>
								<p style={{ ...fonts.fontSize4, ...fonts.paragraph, color: colors.greyDarkPrimary }}>Succesfully created company</p>
								<div style={{ width: "100%", display: "flex", marginTop: "20px" }}>
									<NewButton
										buttonType={ButtonTypes.primaryButton}
										content={"Create new company"}
										overrides={{
											baseStyles: { width: "fit-content", backgroundColor: colors.greyTertiary, height: "30px", padding: "0 10px" },
											contentStyles: { color: colors.greyDarkPrimary, textShadow: "none", ...fonts.fontSize4 },
											hoverStyles: { backgroundColor: colors.greyLightPrimary, color: colors.greyDarkPrimary }
										}}
										onClick={() => { handleResetState(); }}
									/>
								</div>
							</> }
						</>
					}
					/>
					</div>
			</frames._page_inner_content_scroll>
		</frames.Page_inner>
	)
}